<template>
    <div>
        {{ row.total_attendance | commaNumber }}
        <span
            class="subtext"
        >{{ row.capacity | commaNumber }}</span>
    </div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
